const staticText = {
  dateButtonGroupConfig: [{
    label: '30d',
    value: 30,
  },
  {
    label: '7d',
    value: 7,
  },
  {
    label: '1d',
    value: 1,
  }],
  apiRequestsOverTimeChart: {
    xAxisLabel: timeInterval => (timeInterval > 1 ? 'Date' : 'Time'),
    yAxisLabel: 'API requests',
    successLabel: 'Success',
    errorLabel: 'Error',
    total: 'Total',
    emptyStateTitle: 'No requests found',
    emptyStateSubtitleWhileOnboarding: 'Make your first API request to view this chart',
    emptyStateSubtitleAfterOnboarding: 'Try adjusting the timeframe to view API request data',
    upgradeContent: {
      title: 'Upgrade to view more days',
      description: 'This feature is only available to customers on custom plans. Upgrade your plan to view more days and data on your API requests over time.',
      upgradeButton: {
        text: 'Upgrade plan',
        path: '/team/billing',
      },
    },
  },
  connectedVehiclesOverTimeChart: {
    xAxisLabel: timeInterval => (timeInterval > 1 ? 'Date' : 'Time'),
    yAxisLabel: 'Connected vehicles',
    emptyStateTitle: 'No vehicles found',
    emptyStateSubtitle: 'Connect a vehicle to view this chart',
    upgradeContent: {
      title: 'Upgrade to view more days',
      description: 'This feature is only available to customers on custom plans. Upgrade your plan to view more days and data on your connected vehicles over time.',
      upgradeButton: {
        text: 'Upgrade plan',
        path: '/team/billing',
      },
    },
  },
  top5MakesByConnectedVehiclesChart: {
    xAxisLabel: 'Connected vehicles',
    yAxisLabel: 'Makes',
    inactiveLabel: 'Inactive',
    activeLabel: 'Active',
    tooltipTitle: 'Top 5 makes',
    emptyStateTitle: 'No vehicles found',
    emptyStateSubtitle: 'Connect a vehicle to view this chart',
    emptyStateButton: 'Connect a vehicle',
    total: 'Total',
    upgradeContent: {
      title: 'Upgrade to view more days',
      description: 'This feature is only available to customers on custom plans. Upgrade your plan to view more days and data on your top 5 makes of connected vehicles.',
      upgradeButton: {
        text: 'Upgrade plan',
        path: '/team/billing',
      },
    },
  },
};

export default staticText;
